<template>
  <div class="posts">
    <div class="card">
      <div class="card-body">
        <h5 class="card-title">{{ post.title }}</h5>
        <h3>Par Afrik Eveil| Catégorie: {{ post.name }}</h3>
        <timeago :datetime="post.created_at" locale="en"></timeago>
        <div class="card-text" v-html="post.content.substring(0, 100)"></div>
        <router-link :to="`/blog/${post.slug}`">Read more</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Posts",
  props: {
    post: {}
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
